import Marquee from "react-fast-marquee";
import { useLang } from "../i18n";

const CERTS = [
  { img: "/cert-halal.png", label: "Halal Indonesia" },
  { img: "/cert-iso.png", label: "ISO 9001:2015" },
  { img: "/cert-iso22000.png", label: "ISO 22000" },
  { img: "/cert-sni.png", label: "SNI Indonesia" },
  { img: "/cert-bpom.png", label: "BPOM" },
];

export const TrustBar = () => (
  <div data-testid="trust-bar" className="bg-clara-espresso border-y border-white/10 py-8">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16">
      {CERTS.map((c) => (
        <div key={c.label} className="flex items-center gap-4 text-clara-cream/90">
          <div className="bg-clara-cream rounded-full h-16 w-16 flex items-center justify-center p-2.5 shrink-0">
            <img src={c.img} alt={c.label} loading="lazy" decoding="async" className="max-h-full max-w-full object-contain" />
          </div>
          <span className="font-data text-xs tracking-[0.2em] uppercase">{c.label}</span>
        </div>
      ))}
    </div>
  </div>
);

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
  <div data-testid="editorial-marquee" className="bg-clara-cream border-y border-clara-espresso/10 py-8 overflow-hidden">
    <Marquee speed={40} gradient={false}>
      {t.marquee.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display italic text-4xl md:text-6xl text-clara-espresso px-8">{w}</span>
          <span className="text-clara-terracotta text-3xl">◦</span>
        </div>
      ))}
    </Marquee>
  </div>
  );
};
